import { createUseStyles } from 'react-jss';

export default createUseStyles({
  button: {
    color: '#fff',
    fontFamily: '"Manrope", sans-serif',
    fontWeight: 800,
    fontSize: '16px',

    background: process.env.REACT_APP_PRIMARY_COLOR,
    cursor: 'pointer',
    zIndex: 10,

    display: 'inline-block',
    textAlign: 'center',
    verticalAlign: 'middle',
    userSelect: 'none',
    border: 'none',
    height: '56px',
    padding: '0.375rem 0.75rem',
    lineHeight: '1.5',
    borderRadius: '12px',
    transition: 'background 0.15s ease-in-out, box-shadow 0.15s ease-in-out',

    textDecoration: 'none',

    boxShadow: '0 20px 10px -15px rgba(200, 216, 225, 0.3)',

    '&:disabled': {
      cursor: 'not-allowed',
    },

    '&:hover': {
      // background: 'linear-gradient(to left, #667076, #b0bdc4)',
      background: 'linear-gradient(to left, #B9C7D1, #D2E0E7)',
      borderColor: 'none',
      textDecoration: 'none',
      color: '#fff',
    },

    '&:active': {
      background: 'linear-gradient(to left, #B9C7D1, #D2E0E7)',
      borderColor: 'none',
      textDecoration: 'none',
      color: '#fff',
    },

    '&:focus': {
      boxShadow: 'none',
      outline: 0,
      textDecoration: 'none',
      color: '#fff',
    },
  },
});
